import Vue from 'vue'; 
//eCharts
import "echarts";
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';

// import Vue2MapboxGL from 'vue2mapbox-gl';
// // You might want to import the relevant css, for example:
// import 'mapbox-gl/dist/mapbox-gl.css';
// // for the v-mapbox-geocoder
// import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
// import VueYoutube from 'vue-youtube'


Vue.component('v-chart', ECharts)
// Vue.use(Vue2MapboxGL);
// Vue.use(VueYoutube)